module.exports = __webpack_public_path__ + "static/media/logo-no-text.723db622.png";